import React, { useEffect, useState } from 'react'

import { Icon } from '../../../../components/Icon'
import {
  policyHeader,
  WhistleblowingHeadersAdmin,
} from '../../../../data/index'

import Pagination from '../../../../components/UI/Pagination'
import '../../../../App.css'
import {
  whistleblowingResponse,
  whistleblowingResponseObj,
} from '../../../../utils/types'

import { toast } from 'react-toastify'
import { useQuery } from 'react-query'
import { formatDate } from '../../../../utils/utils'
import Loading from '../../../../components/UI/Loading'
import { getWhistleBlowing } from '../../../../api/lead/whistleblowing'
import WhistleblowingCaseView from './WhistleblowingCaseView'

interface WhistleblowingHeadersInterface {
  ID: string
  Status: string
  Subject: string
  'Report Type': string
  'Date Reported': string
  'Updated At': string
  'Created By': string
  'Updated By': string
}

const WhistleblowingGroupGovernor = () => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [selected, setSelected] = useState<{
    id: string
    schoolId: string
  } | null>(null)

  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('reportNo')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  const handlePageChange = (pageNumber: number): void => {
    setCurrentPage(pageNumber)
    // You can add additional logic here, like fetching data for the new page
  }

  const getWhistleBlowingData =
    async (): Promise<whistleblowingResponseObj> => {
      const response = (await getWhistleBlowing(
        // currentPage,
        sortBy,
        sortOrderValue
      )) as whistleblowingResponse

      if (response?.status != 'successful') {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
      return response?.data
    }

  const whistleBlowing = useQuery('whistleBlowing', getWhistleBlowingData)

  const calculatePageCount = (dataLength: number): number => {
    if (dataLength < 4) {
      return 1
    } else {
      return Math.ceil(dataLength / 3)
    }
  }

  useEffect(() => {
    whistleBlowing.refetch()
  }, [currentPage])

  useEffect(() => {
    whistleBlowing.refetch() // Refetch Whistle Blowing when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  if (selected) {
    return (
      <div
        className={
          'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-8  '
        }
      >
        <WhistleblowingCaseView
          id={selected.id}
          schoolId={selected.schoolId}
          onBack={() => setSelected(null)}
          onUpdated={() => whistleBlowing.refetch()}
        />
      </div>
    )
  }

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-8  '
      }
    >
      <div className="flex flex-col gap-[30px] w-full relative h-full">
        <div className={'flex w-full justify-between items-start '}>
          <div className="flex-col w-[50%] gap-[20px]">
            <p className={'text-[18px] text-text2 font-bold '}>
              Whistleblowing
            </p>
            <p className={'text-[14px] text-text1 font-normal mt-2'}>
              Select a report to open it.
            </p>
          </div>

          <div className={'flex flex-row gap-[15px]'}></div>
        </div>
        {/* content container */}

        {whistleBlowing.isLoading && (
          <div className="flex justify-center items-center h-screen">
            <Loading size="large" />
          </div>
        )}
        {!whistleBlowing.isLoading && (
          <div id={'#container'} className="w-full ">
            <>
              <div id={'#container'} className="w-full flex mt-6">
                {/* table component */}
                <div className="overflow-hidden rounded-[16px] w-full">
                  <table className="rounded-[16px] overflow-hidden border w-full border-white">
                    <thead>
                      <tr className="bg-gray2 cursor-pointer">
                        {WhistleblowingHeadersAdmin?.map(
                          (item, index: number) => {
                            return (
                              <th
                                key={index}
                                className={`w-1/8 px-4 py-3 text-left ${policyHeader?.length - 1 === index ? 'border-0 border-gray2' : 'border border-white'}`}
                              >
                                <div className="flex items-center">
                                  <p className="text-text1 font-semibold text-sm flex-1">
                                    {item.replace(/_/g, ' ')}
                                  </p>
                                  <div
                                    className="cursor-pointer"
                                    onClick={() => {
                                      let sortBy = ''
                                      switch (
                                        item as keyof WhistleblowingHeadersInterface
                                      ) {
                                        case 'ID':
                                          sortBy = 'reportNo'
                                          break
                                        case 'Status':
                                          sortBy = 'status'
                                          break
                                        case 'Subject':
                                          sortBy = 'subject'
                                          break
                                        case 'Report Type':
                                          sortBy = 'reportType'
                                          break
                                        case 'Date Reported':
                                          sortBy = 'createdAt'
                                          break
                                        case 'Updated At':
                                          sortBy = 'updatedAt'
                                          break
                                        case 'Created By':
                                          sortBy = 'createdByName'
                                          break
                                        case 'Updated By':
                                          sortBy = 'updatedByName'
                                          break
                                        default:
                                          break
                                      }
                                      handleSort(sortBy)
                                    }}
                                  >
                                    <Icon
                                      name={'IconChevronDown'}
                                      width={16}
                                      height={16}
                                      strokeWidth={1}
                                      stroke={'#67A5B9'}
                                    />
                                  </div>
                                </div>
                              </th>
                            )
                          }
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {whistleBlowing?.data?.data?.map((item, index) => (
                        <>
                          <tr
                            key={index}
                            className="bg-gray1 cursor-pointer"
                            onClick={() =>
                              setSelected({
                                id: item.id,
                                schoolId: item.schoolId,
                              })
                            }
                          >
                            {/* Example row */}
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.reportNo}
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <div className="px-[10px] w-fit flex justify-center items-center bg-lightGreen h-[28px] rounded-[100px]">
                                <p className="text-text2 font-medium text-xs leading-5">
                                  {item.status}
                                </p>
                              </div>
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <p className="text-text1 font-semibold text-sm leading-6">
                                {item.subject}
                              </p>
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <p className="text-text1 font-semibold text-sm leading-6">
                                {item.reportType}
                              </p>
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <p className="text-text1 font-semibold text-sm leading-6">
                                {formatDate(item.createdAt)}
                              </p>
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <p className="text-text1 font-semibold text-sm leading-6">
                                {formatDate(item.updatedAt)}
                              </p>
                            </td>
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <p className="text-xs text-text1 font-medium leading-5">
                                {item.createdByName}
                              </p>
                            </td>
                            <td className="px-4 h-[48px] py-2 border border-white">
                              <p className="text-xs text-text1 font-medium leading-5">
                                {item.updatedByName == null
                                  ? ''
                                  : item.updatedByName}
                              </p>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          </div>
        )}

        <div className="absolute bottom-[20px]">
          {/* Your content here */}

          <Pagination
            currentPage={currentPage}
            totalPages={calculatePageCount(
              Number(whistleBlowing?.data?.count) || 0
            )}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  )
}

export default WhistleblowingGroupGovernor
